module.exports = __webpack_public_path__ + "img/media-android@2x.96e61d45.png";